(function () {
  const REVIEWS_ID = 'product-reviews'
  const REVIEWS_HASH = `#${REVIEWS_ID}`
  const JUNIP_SELECTORS = [
    '.junip-product-review-container',
    '.junip-product-review-summary-container',
    '.manual-blocks__app [class*="junip-product"]'
  ]
  const OBSERVER_TIMEOUT_MS = 15000

  let pendingScroll = false
  let observer = null
  let observerTimeout = null

  function findJunipTarget() {
    for (const selector of JUNIP_SELECTORS) {
      const element = document.querySelector(selector)
      if (element) { return element }
    }
    return null
  }

  function getScrollTarget() {
    return findJunipTarget() || document.getElementById(REVIEWS_ID)
  }

  function scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  }

  function scrollToReviews() {
    const target = getScrollTarget()
    if (!target) { return false }

    target.scrollIntoView({ block: 'start', behavior: scrollBehavior() })
    return true
  }

  function stopObserver() {
    observer?.disconnect()
    observer = null
    if (observerTimeout) {
      clearTimeout(observerTimeout)
      observerTimeout = null
    }
  }

  function startObserver() {
    if (observer) { return }

    observer = new MutationObserver(() => {
      if (!pendingScroll || !findJunipTarget()) { return }

      pendingScroll = false
      scrollToReviews()
      stopObserver()
    })

    observer.observe(document.body, { childList: true, subtree: true })

    observerTimeout = window.setTimeout(() => {
      pendingScroll = false
      stopObserver()
    }, OBSERVER_TIMEOUT_MS)
  }

  function requestScrollToReviews() {
    pendingScroll = true
    startObserver()
    scrollToReviews()

    if (findJunipTarget()) {
      pendingScroll = false
      stopObserver()
    }
  }

  function isProductReviewsLink(link) {
    try {
      const url = new URL(link.href, window.location.href)
      return url.hash === REVIEWS_HASH
        && url.pathname === window.location.pathname
        && url.search === window.location.search
    } catch (error) {
      return false
    }
  }

  function handleClick(event) {
    const link = event.target.closest(`a[href*="${REVIEWS_HASH}"]`)
    if (!link || !isProductReviewsLink(link)) { return }

    event.preventDefault()
    event.stopImmediatePropagation()

    history.pushState(null, '', REVIEWS_HASH)
    requestScrollToReviews()
  }

  function handleHashNavigation() {
    if (window.location.hash !== REVIEWS_HASH) { return }
    requestScrollToReviews()
  }

  function init() {
    if (!document.getElementById(REVIEWS_ID) && !document.querySelector('.shopify-section--manual-blocks')) {
      return
    }

    document.addEventListener('click', handleClick, true)
    window.addEventListener('hashchange', handleHashNavigation)

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleHashNavigation)
    } else {
      handleHashNavigation()
    }
  }

  init()
})()
